module.exports = __webpack_public_path__ + "static/media/like_product_4.d5ce295b.svg";